export class ResidencyFacultyModel {
    firstName: string;
    lastName: string;
    emailAddress: string;
    dateAdded: Date;
    roleName: string;
    contactNumber: string;
    contactWebRoleId: string;
}
